import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function AppHeader({
  logo,
  home,
  menuType,
  username,
  notificationCount,
  onOpenMenu,
  onOpenNotifications
}) {
  const navigate = useNavigate(); // ✅ FIX

  return (
    <header className={`app-header ${menuType}-header`}>
      <div className="header-left">
        <Link to={home}>
          <img
            src={logo}
            alt={`${menuType} logo`}
            className="app-logo"
          />
        </Link>
      </div>

      <div className="header-right">

      {username && (
        <span className="welcome-text">
          Welcome, <strong>{username}</strong>!
        </span>
      )}

      {notificationCount > 0 && (
        <div
          className="notification-badge"
          onClick={onOpenNotifications}
        >
          🔔 {notificationCount}
        </div>
      )}

      <button
        className="hamburger-btn"
        onClick={onOpenMenu}
      >
        <Menu size={28} />
      </button>

    </div>

    </header>
  );
}